import { render, staticRenderFns } from "./projectAddSurvey.vue?vue&type=template&id=ca5a0b42&scoped=true"
import script from "./projectAddSurvey.vue?vue&type=script&lang=js"
export * from "./projectAddSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5a0b42",
  null
  
)

export default component.exports